var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRedeemSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 88,
    viewBox: "0 0 94 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.174,
    cy: 44.1995,
    rx: 30.8312,
    ry: 31.0588,
    fill: "#42BE40",
    fillOpacity: 0.36
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.0076,
    cy: 3.27356,
    rx: 3.24957,
    ry: 3.27356,
    fill: "#3463AF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.7481,
    cy: 24.2898,
    rx: 3.55745,
    ry: 3.58371,
    fill: "#3463AF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.49639,
    cy: 45.1707,
    rx: 2.94097,
    ry: 2.96268,
    fill: "#3463AF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9068,
    cy: 80.7839,
    rx: 3.55745,
    ry: 3.58371,
    fill: "#3463AF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.005,
    cy: 66.0232,
    rx: 3.55745,
    ry: 3.58371,
    fill: "#3463AF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.6367,
    cy: 78.4436,
    rx: 1.18582,
    ry: 1.19457,
    fill: "#3463AF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.2617,
    cy: 20.7063,
    rx: 1.18582,
    ry: 1.19457,
    fill: "#3463AF"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.1199,
    cy: 49.3752,
    rx: 1.18582,
    ry: 1.19457,
    fill: "#3463AF"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.7852,
    cy: 65.303,
    rx: 1.18582,
    ry: 1.19457,
    fill: "#3463AF"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8526,
    cy: 17.1223,
    rx: 1.18582,
    ry: 1.19457,
    fill: "#3463AF"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.1116,
    cy: 8.52758,
    rx: 1.18582,
    ry: 1.19457,
    fill: "#3463AF"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.7852,
    cy: 18.3166,
    rx: 1.18582,
    ry: 1.19457,
    fill: "#3463AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1738 64.1091C60.0889 64.1091 68.9374 55.1953 68.9374 44.1996C68.9374 33.2038 60.0889 24.29 49.1738 24.29C38.2586 24.29 29.4102 33.2038 29.4102 44.1996C29.4102 55.1953 38.2586 64.1091 49.1738 64.1091Z",
    fill: "#42BE40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9805 52.5147L37.9092 46.0693C37.078 45.1869 37.1257 43.7908 38.0153 42.9663C38.905 42.1419 40.3124 42.1893 41.1436 43.0716L45.8267 48.0432L53.2395 41.1734C53.3061 41.1116 53.3758 41.0549 53.4478 41.0028L56.9338 37.7722C57.8234 36.9478 59.231 36.9952 60.0621 37.8777C60.8933 38.7599 60.8454 40.1562 59.9559 40.9806L49.309 50.8477L49.2976 50.8357L45.6147 54.2489L43.9805 52.5147Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8012 83.2818L49.8741 81.2305L51.1615 83.2818L53.5219 83.692L51.5907 85.333L52.0199 87.9997L49.8741 86.7689L47.5138 87.9997L47.9429 85.333L46.0117 83.692L48.8012 83.2818Z",
    fill: "#F0745C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19213 29.4417L4.98268 27.873L5.93133 29.4417L7.67053 29.7554L6.24755 31.0103L6.56377 33.0495L4.98268 32.1083L3.24348 33.0495L3.5597 31.0103L2.13672 29.7554L4.19213 29.4417Z",
    fill: "#F0745C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3912 3.07785L51.0688 1.62988L51.8819 3.07785L53.3727 3.36744L52.153 4.52581L52.424 6.40817L51.0688 5.53939L49.578 6.40817L49.8491 4.52581L48.6294 3.36744L50.3912 3.07785Z",
    fill: "#F0745C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7236 37.6104L89.7965 35.4385L91.0839 37.6104L93.4443 38.0448L91.5131 39.7824L91.9422 42.6059L89.7965 41.3027L87.4361 42.6059L87.8653 39.7824L85.9341 38.0448L88.7236 37.6104Z",
    fill: "#F0745C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRedeemSuccessIcon);
export default __webpack_public_path__ + "static/media/newRedeemSuccessIcon.1e4e464d4e974f8875fd622e1d7be0ae.svg";
export { ForwardRef as ReactComponent };